import axios from 'axios';

const TermsOfServiceService = {
  async getTermsOfService() {
    const response = await axios.get('/terms_of_service', {
      params: {
        type: 'lender',
      },
      headers: {
        Accept: '*/*',
      },
    });

    return response.data;
  },
};

export default TermsOfServiceService;
